import { render, staticRenderFns } from "./SeminarOrder.vue?vue&type=template&id=81aa57b0&scoped=true&"
import script from "./SeminarOrder.vue?vue&type=script&lang=js&"
export * from "./SeminarOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa57b0",
  null
  
)

export default component.exports